import React,{ Component } from 'react';
import { connect } from 'react-redux'

import './styles.css'
import CartCTA from './CartCta';
import LpCreditCardModal from '../card_modal';
import {
  ckUpdatePromoCode,
  ckSendPromoCode
} from "../../../redux/actions/checkout_operations";
import { lpPattern, P_CHECK_PROMO } from "../../../tracking/pattern_detector";
import lpApp from '../../../app/lp_app';
import CartPromoCode from './CartPromoCodeBtn';


class CartNew extends Component {
  state = {
    showPromoCodeInput: false,
    showPaymentModal: false,
  };

  showPaymentModal = () => {
    // Tracking opened payment popup
    const eventParams = {};

    eventParams["Chosen price"] = parseFloat(lpApp.ops.checkout.getPackPrice());
    eventParams["Total price"] = parseFloat(lpApp.ops.checkout.getTTCPrice());
    eventParams["Chosen pack"] = "first_price";

    if (lpApp.subscription && this.props.chosenPack === 1) {
      eventParams["Chosen pack"] = "abonnement";
    }
    lpevents.trackPopUpCheckout()
    lpevents.track("", eventParams);
    this.setState({ showPaymentModal: true });
  };

  closePaymentModal = () => this.setState({ showPaymentModal: false });

  showPromoCodeInput = () => this.setState({ showPromoCodeInput: true });


  sendPromo = () => {
    this.props.checkPromo(this.props.promo_code, lpApp.contractUniqid);
    this.setState({showPromoCodeInput: false})
  }

  updatePromoCode = (event) => {
    this.props.updatePromo(event.target.value)
  }

  getCartWidth = () => {
    const windowWidth = window.innerWidth;
    if(windowWidth <= 990) {
      this.setState({ windowWidth });
    }
  }

  getTotalWithPromoCode = (total, hasValidPromoCode, PromoPercentage) => {
    return (hasValidPromoCode && total * (1 - PromoPercentage)) || total
  } 

  render() {
    const { showPaymentModal, showPromoCodeInput, windowWidth } = this.state;
    const { promo_code, promo_loading, promo_percentage, upsellItems, pack_priceHT } = this.props

    const hasPromoCode = promo_code.length > 0;
    const selectedUpsellItems = upsellItems.filter(item => item.isSelected)
    const upsellPaymentData = upsellItems.map(item => item.isSelected)
    const isValidPromoCode =
      hasPromoCode &&
      typeof promo_percentage !== "string" &&
      promo_percentage !== 0;
      
    const isInvalidPromoCode = typeof promo_percentage === 'string';
    
    const promoDiscountRate = parseFloat(promo_percentage) * 100;

    let packPriceWithCode = pack_priceHT && this.getTotalWithPromoCode(pack_priceHT, isValidPromoCode, promo_percentage)

    let totalTTC = packPriceWithCode * 1.2

    let tvaPrice = totalTTC / 120 * 20;
    
    if (selectedUpsellItems.length > 0) {
      selectedUpsellItems.forEach( upsellItem => {
        const { priceHT } = upsellItem
        const newPrice = packPriceWithCode + priceHT
        totalTTC = newPrice * 1.2
        tvaPrice = (totalTTC / 6)
      })
    }

    return (
      <div className="cart-display-container">
        <div className="cart-content-container" style={{width: `${windowWidth}px`}}>
          <div className="cart-subtotalContainer">
            <p className="cart-subtotalContainer-text">Tarif HT</p>
            <p className="cart-subtotalContainer-text">{`${pack_priceHT && pack_priceHT.toFixed(2)} €`}</p>
          </div>

          {isValidPromoCode && (
            <div>
              <div className="cart-subtotalContainer">
                <p className="cart-subtotalContainer-text">Code de réduction</p>
                <p className="cart-subtotalContainer-text">{`- ${promoDiscountRate} %`}</p>
              </div>
              <div className="cart-subtotalContainer">
                <p className="cart-subtotalContainer-text">Sous-total</p>
                <p className="cart-subtotalContainer-text">{`${packPriceWithCode.toFixed(2)} €`}</p>
              </div>
            </div>

          )}

          {selectedUpsellItems.length > 0 && selectedUpsellItems.map((upsellItem, index) => {
            const { name, priceHT } = upsellItem
              return (
              <div className="cart-subtotalContainer" key={`upsellItem_${index + 1}`}>
                <p className="cart-subtotalContainer-text">{name}</p>
                <p className="cart-subtotalContainer-text">{`${priceHT.toFixed(2)} €`}</p>
              </div>)
            }
          )}

          <div className="cart-subtotalContainer">
            <p className="cart-subtotalContainer-text">TVA à 20%</p>
            <p className="cart-subtotalContainer-text">{`${tvaPrice.toFixed(2)} €`}</p>
          </div>

          <div className="cart-totalContainer">
            <p className="cart-totalContainer-text">Total</p>
            <p className="cart-totalContainer-text">{`${totalTTC.toFixed(2)} €`}</p>
          </div>
          <CartCTA ctaHandler={this.showPaymentModal} />
          <CartPromoCode
            showInput={this.showPromoCodeInput}
            shouldShowPromoCodeInput={showPromoCodeInput}
            isLoadingPromoCode={promo_loading}
            validateCode={this.sendPromo}
            updatePromoCode={this.updatePromoCode}
            isValidPromoCode={isValidPromoCode}
            isInvalidPromoCode={isInvalidPromoCode}
          />
          <LpCreditCardModal
            show={showPaymentModal}
            closeEvent={this.closePaymentModal}
            totalTTC={totalTTC}
            upsell={upsellPaymentData}
          />
        </div>
      </div>
    );
  }
};

const mapStateToProps = state => ({
  title: state.contract.name,
  first_price: state.checkout_operations.prices.first_price,
  second_price: state.checkout_operations.prices.second_price,
  chosenPack: state.checkout_operations.pack,
  has_call: state.checkout_operations.has_call,
  has_letter: state.checkout_operations.has_letter,
  letter_number: state.checkout_operations.letter.number,
  pack_priceHT:
    state.checkout_operations.contract_meta_id === 302
      ? state.checkout_operations.prices.first_price
      : state.checkout_operations.prices.second_price,
  promo_code: state.checkout_operations.promo_code,
  promo_loading: state.checkout_operations.promo_loading,
  promo_percentage: state.checkout_operations.promo_percentage,
  price_loading: state.loading_details.pricing,
  client_email: state.account_settings.mail
});


const mapDispatchToProps = dispatch => ({
  updatePromo: val => {
    dispatch(ckUpdatePromoCode(val));
  },
  checkPromo: (val, contractId) => {
    dispatch(ckSendPromoCode(val, contractId));
    lpPattern.trackInPayment(P_CHECK_PROMO);
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(CartNew);



// WEBPACK FOOTER //
// ./src/components/buy/Cart/CartNew.js